module.exports = ".l-locationpicker-class {\n position: relative;\n display: inline-block;\n overflow: hidden;\n width: 500px;\n height: 400px;\n}\n\n@media (max-width: 500px) {\n\n  .l-locationpicker-class {\n    min-width: 100%;\n    width: 100%;\n    height: auto;\n  }\n\n}\n\n@media (min-width: 768px) {\n\n  .l-locationpicker-class   {\n    width: 700px;\n    height: 500px;\n  }\n\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main